import * as z from "zod/v4";
import { BatchWorkOrderSchema } from "./get-work-order-batch";

export const getPlacingWorkOrdersByTote = {
  name: "getPlacingWorkOrdersByTote" as const,
  input: z.object({
    toteName: z.string().optional(),
    batchIds: z.array(z.string()).optional(),
    locationId: z.string().optional(),
  }),
  output: z.object({
    tote: z.object({ id: z.string(), name: z.string() }).nullable(),
    workOrders: z.array(BatchWorkOrderSchema),
    batchIds: z.array(z.string()),
    locationId: z.string().nullable(),
    lostBin: z.object({ id: z.string(), name: z.string() }).nullable(),
  }),
};
